(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    // Close-outside handling for the filter/sort disclosures. A transparent
  // full-viewport backdrop used to do this, but it swallowed touch scrolling
  // and made the page feel frozen while a dropdown was open, so the page is
  // left fully scrollable and outside clicks are detected here instead.
  var DISCLOSURE_SELECTOR = '.filter-disclosure[open], .sort-disclosure[open]';

  document.addEventListener('pointerdown', function (e) {
    var open = document.querySelectorAll(DISCLOSURE_SELECTOR);

    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(e.target)) {
        open[i].removeAttribute('open');
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var open = document.querySelectorAll(DISCLOSURE_SELECTOR);

    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
    }
  });

  // Only one disclosure open at a time
  document.addEventListener(
    'toggle',
    function (e) {
      if (!e.target.classList.contains('filter-disclosure') && !e.target.classList.contains('sort-disclosure')) return;
      if (!e.target.open) return;

      var open = document.querySelectorAll(DISCLOSURE_SELECTOR);

      for (var i = 0; i < open.length; i++) {
        if (open[i] !== e.target) {
          open[i].removeAttribute('open');
        }
      }
    },
    true,
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.localization-selector').forEach((details) => {
    document.addEventListener('click', (event) => {
      if (details.open && !details.contains(event.target)) {
        details.open = false;
      }
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        details.open = false;
        const summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const active = details.querySelector('[aria-current="true"]');
      if (active) {
        active.focus({ preventScroll: true });
        active.scrollIntoView({ block: 'nearest' });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
